import styles from "./shop.module.css";
import BuyTickets from "../../components/buyTickets/buyTickets";

const Shop = () => {
    return (
        <div>
            <BuyTickets></BuyTickets>
        </div>
    );
}
 
export default Shop;